import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=05bbf064&"
import script from "./NewRegister.vue?vue&type=script&lang=js&"
export * from "./NewRegister.vue?vue&type=script&lang=js&"
import style0 from "./NewRegister.vue?vue&type=style&index=0&id=05bbf064&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bbf064')) {
      api.createRecord('05bbf064', component.options)
    } else {
      api.reload('05bbf064', component.options)
    }
    module.hot.accept("./NewRegister.vue?vue&type=template&id=05bbf064&", function () {
      api.rerender('05bbf064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/NewRegister.vue"
export default component.exports